const $form = document.querySelector('.wpcf7-form');
const $formBtn = document.querySelector('.wpcf7-submit');
const $formError = document.querySelector('.wpcf7-response-output');

// on submit
document.addEventListener('DOMContentLoaded', function () {
  $form.addEventListener('submit', function () {
    $formBtn.disabled = true;
    $form.classList.add('form--loading');
  });
});

// successfully sent
document.addEventListener('DOMContentLoaded', function () {
  $form.addEventListener('wpcf7mailsent', function () {
    $formBtn.disabled = false;
    $form.classList.remove('form--loading');
  });
});

// on submit
document.addEventListener('wpcf7submit', function (event) {
  // validation fail
  if (event.detail.status == 'validation_failed') {
    $formBtn.disabled = false;
    $form.classList.remove('form--loading');
    $formError.classList.add('u--display-block');
  }
});
